import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import LandingV2 from './components/v2/LandingV2';
import PrivacyPolicyV2 from './components/v2/PrivacyPolicyV2';
import MentionsLegalesV2 from './components/v2/MentionsLegalesV2';

// Hash-based routing. The V2 design is now the site-wide look:
//   /              -> home (LandingV2)
//   #privacy       -> Privacy Policy (V2 styled)
//   #mentions      -> Legal notice / Mentions légales (V2 styled)
// Any other hash (e.g. #features) resolves to the home page and scrolls.
function routeFor(hash) {
  if (hash === '#privacy') return 'privacy';
  if (hash === '#mentions') return 'mentions';
  return 'home';
}

function Root() {
  const [route, setRoute] = useState(() => routeFor(window.location.hash));

  useEffect(() => {
    const onHashChange = () => setRoute(routeFor(window.location.hash));
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  if (route === 'privacy') return <PrivacyPolicyV2 />;
  if (route === 'mentions') return <MentionsLegalesV2 />;
  return <LandingV2 />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
